import { defineMessages } from 'react-intl';

export const newAppVersionToastMessageDefinitions = defineMessages({
  newVersionDeployed: {
    id: 'newAppVersionToast.newVersionDeployed',
    defaultMessage:
      'A new version of the application has been deployed. It is recommended to reload the page.',
  },
  reloadButton: {
    id: 'newAppVersionToast.reloadButton',
    defaultMessage: 'Click here to reload.',
  },
});
